import useFeature from "@casino/legacy/client/hooks/feature/useFeature";
import useSite from "@casino/legacy/client/hooks/useSite";
import getEnv from "@casino/legacy/shared/utils/getEnv";
import parse from "@casino/legacy/shared/utils/string/parse";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const CaptchaProvider: FC = ({ children }) => {
  const isRecaptchaV3Enabled = useFeature("isRecaptchaV3Enabled");
  const { site } = useSite();

  const recaptchaV3ApiKeys = parse(
    getEnv("RECAPTCHA_V3_API_KEY") || "{}",
  ) as Partial<Record<Site, string>>;
  const reCaptchaKey = recaptchaV3ApiKeys?.[site] || "";
  if (isRecaptchaV3Enabled) {
    return (
      <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey} useRecaptchaNet>
        {children}
      </GoogleReCaptchaProvider>
    );
  }
  return <>{children}</>;
};

export default CaptchaProvider;
